export default function BermudaMap() {
  return (
<svg viewBox="0 0 440 150" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Silhouette map of Bermuda" className="h-auto w-full">
  <defs>
    <linearGradient id="islandFill" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stopColor="#2a303b" />
      <stop offset="1" stopColor="#181b20" />
    </linearGradient>
  </defs>

  {/* dotted ocean grid */}
  <g fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1">
    <path d="M0 30 H440" /><path d="M0 60 H440" /><path d="M0 90 H440" /><path d="M0 120 H440" />
    <path d="M40 0 V150" /><path d="M110 0 V150" /><path d="M180 0 V150" /><path d="M250 0 V150" /><path d="M320 0 V150" /><path d="M390 0 V150" />
  </g>

  {/* main island arc */}
  <path
    d="M18 108
       C 50 100, 78 96, 108 88
       C 140 80, 168 74, 198 66
       C 232 57, 264 50, 298 40
       C 330 31, 362 24, 396 16
       L 400 24
       C 366 33, 334 41, 302 50
       C 268 60, 236 68, 204 77
       C 172 86, 142 93, 112 101
       C 80 110, 50 116, 22 121
       Z"
    fill="url(#islandFill)" stroke="rgba(0,230,118,0.35)" strokeWidth="1.5"
  />

  {/* small outlying islands */}
  <ellipse cx="410" cy="13" rx="5" ry="2.4" fill="#181b20" stroke="rgba(0,230,118,0.3)" strokeWidth="1" />
  <ellipse cx="424" cy="10" rx="3.4" ry="1.7" fill="#181b20" stroke="rgba(0,230,118,0.3)" strokeWidth="1" />
  <ellipse cx="12" cy="128" rx="4" ry="2" fill="#181b20" stroke="rgba(0,230,118,0.3)" strokeWidth="1" />

  {/* dashed green road line running the length of the island */}
  <path
    d="M24 112 C 60 103, 110 92, 165 78 C 220 64, 290 45, 392 20"
    fill="none" stroke="#00E676" strokeWidth="2" strokeDasharray="10 9" strokeLinecap="round"
  />

  {/* direction arrows */}
  <g fill="none" stroke="#00E676" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M330 47 l 10 -12 M340 35 l -8 1 M340 35 l 1 8" />
  </g>
</svg>
  );
}
